<template>
  <section class="first-frame">
    <h2><span>Порт</span> транзит</h2>
    <p>теперь и экспедитор</p>
    <p class="phone">8 800 250-75-31</p>
    <ul>
      <li>Прямые контракты от экспортера</li>
      <li>Наша комиссия 1 р/т</li>
      <li>С нами удобно</li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'FirstFrame',
}
</script>

<style lang="sass">
.first-frame
  font-family: 'Roboto', sans-serif;
  background: #eff0f2 url("~@/assets/img/promo_back.jpg") no-repeat 100%;
  height: 100%;
  background-size: contain;
  padding-left: 200px;
  color: #000;
  font-weight: bold;
  h2
    font-size: 120px;
    margin: 0;
    font-weight: bold;
    padding-top: 50px;
    span
      color: #60BEF1;
  p
    font-size: 55px;
    line-height: 100px
    margin: 0;
    &.phone
     font-size: 70px;
  ul
    color: #EFAC00;
    font-size: 70px;
    list-style: none;
    padding: 0;
    width: 750px;
    margin-top: 100px;
    li
      position: relative;
      margin-bottom: 25px;
      &:before
        position: absolute;
        content: '';
        top: 20px;
        left: -160px;
        width: 140px;
        height: 50px;
        background-image: url("~@/assets/img/promo-list.svg");
        background-size: contain;
</style>
